import config from '@/v2/config';

export const HEADER_TITLE = config.REACT_APP_HEADER_TITLE || 'HEADER.TITLE';
export const HEADER_TITLE_MULTI_EVENT = config.REACT_APP_HEADER_TITLE || 'HEADER.TITLE_MULTI_EVENT';
